'use strict';

class Customer {
	constructor() {
		_.extend(this, {
			id: null,
			phone_number: null,
			email: null,
			user_token: null
		})
	}
}
export default Customer;


// WEBPACK FOOTER //
// ./client/app/common/models/Customer.js